<script setup lang="ts">
    import { ref, computed, Ref, watch, onBeforeUnmount } from 'vue';
    import Highlighter from 'vue-highlight-words'
    import { getAddresses } from '@/services'
    import CustomInput from '@/views/components/CustomInput.vue';
    // @ts-ignore
    import i18n from '@/localization/i18n';

    // Props
    const props = withDefaults(defineProps<{
        town?: string
        zipcode?: string|null
        addressItem?: any
        label?: string|null
        placeholder?: string|null
        isDisabled?: boolean | null
        maxLength?:string | null
        classes?: any[]
        showZipcode?:boolean | null
        useMunicipality?:boolean | null
        showLabel?:boolean
    }>(), {
        showLabel: true,
    })

    // Emits
    const emit = defineEmits(['update:town', 'update:zipcode','update:addressItem'])

    // Local variables
    const t = i18n.global.t

    // Refs
    const searchTerm  = ref(props.town ?? '')
    const maxLength  = ref(props.maxLength ?? '')
    const searchAddressesArray = ref([])
    const town = ref('')
    const zipcode: Ref<string|null> = ref(null)
    const addressItem: Ref<any> = ref(null)
    const searchFocus = ref(false)
    const selectAdressClick = ref(false)
    const isDropdownHidden = ref(true)

    const labelText = ref(props.label ?? null)
    const placeholderText = ref(props.placeholder ?? null)
    const isDisabled = ref(props.isDisabled ?? false)
    let classList: Ref<any> = ref(props.classes)

    const showZipcode = ref(props.showZipcode ?? false)
    const useMunicipality = ref(props.useMunicipality ?? false)
    const showLabel = ref(props.showLabel ?? true)


    // Computed variables
    const searchAddresses: any = computed(() => {
        return searchAddressesArray.value
    });
    
    // Functions
    const selectAdress = (address: any,coordinates?: any) => {
        zipcode.value = address.postcode
        if(showZipcode.value === true) {
            town.value = address.city + (zipcode.value ? ' ('+zipcode.value+')':  "")
        } else {
            town.value = address.city 
        }

        if(addressItem){
            let newAdr = address
            newAdr.y = coordinates[1]
            newAdr.x = coordinates[0]
            newAdr.city = address.city
            addressItem.value = newAdr
        }

        searchTerm.value = town.value
        emit('update:town', searchTerm.value)
        emit('update:zipcode', zipcode.value)
        if(addressItem) emit('update:addressItem', addressItem.value)
        selectAdressClick.value = true
        hideDropdown()
    }

    const onInput = (event: any) => {
        searchFocus.value = true
        selectAdressClick.value = false 
        if (searchTerm.value.length > 2) {
            getAddresses(searchTerm.value, useMunicipality.value)
                .then((data) => {
                    searchAddressesArray.value = data.features
                    if (searchAddressesArray.value.length > 0) {
                        isDropdownHidden.value = false
                    }
                }).catch(() => {})
        }
        else {
            searchAddressesArray.value = []
        }
        emit('update:town', searchTerm.value)
    }

    const hideDropdown = () => {
        isDropdownHidden.value = true
    }
    const onBlur = (event:any) => {
        searchFocus.value = false;
    }

    // Watch for changes in props.town
    const unwatchProps = watch(() => props.town, (newValue) => {
        searchTerm.value = newValue!; // Update local searchTerm when prop changes
        if(searchTerm.value === "") isDropdownHidden.value = true
    });

    onBeforeUnmount(() => {
        unwatchProps()
    })
</script>

<template>
    <div>
        <label v-if="showLabel" 
            class="form-label" 
            for="country-floating">{{ labelText ?? t('g_frm_city') }}</label>
        <CustomInput 
            v-model:value="searchTerm"
            :disabled="isDisabled"
            :classes="classList"
            type="search"
            :maxlength="maxLength"
            id="country-floating"
            :placeholder="placeholderText ?? t('w_frm_wkSearch_cityPl')"
            @blur="onBlur"
            @input="onInput"
        />
        <input 
            v-if="false" 
            v-model="searchTerm" 
            @blur="onBlur" 
            type="search" 
            class="form-control text-start mb-0"
            dir="ltr" 
            spellcheck="false" 
            autocorrect="off" 
            autocomplete="off"
            autocapitalize="off" 
            aria-controls="autoComplete_list_1"
            aria-autocomplete="both" 
            :placeholder="t('w_frm_searchAddress')">
        <div class="dropdown">
            <button 
                v-show="false" 
                class="btn btn-secondary dropdown-toggle" 
                type="button" 
                data-bs-toggle="dropdown" 
                aria-expanded="true">
                Dropdown button
            </button>
            <div 
                v-if="!isDropdownHidden" 
                id="autoComplete_list_1" 
                class="dropdown-menu show mt-0">
                <div v-for="address in searchAddresses">
                    <button 
                        class=" btn-light dropdown-item" 
                        @click="selectAdress(address.properties, address.geometry.coordinates)">
                        <Highlighter 
                            class="my-highlight"
                            highlightClassName="highlight"
                            :searchWords="searchTerm.split(' ')"
                            :autoEscape="true"
                            :textToHighlight="address.properties.city + (address.properties.postcode ? ' ('+address.properties.postcode+')' : '')" />
                    </button>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
@import url('@/assets/css/bootstrap-extended2.css');
@import url('@/assets/css/bootstrap-extended.css');
@import url('@/assets/css/animate.css');
@import url('@/assets/css/main.css');
.form-label {
    color: black;
    font-size: 14px;
}
</style>